import { render } from "./StandardDetailView.vue?vue&type=template&id=efde61bc&scoped=true"
import script from "./StandardDetailView.vue?vue&type=script&lang=js"
export * from "./StandardDetailView.vue?vue&type=script&lang=js"

import "./StandardDetailView.vue?vue&type=style&index=0&id=efde61bc&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efde61bc"]])

export default __exports__